module.exports = __webpack_public_path__ + "static/octavateDatabase-a788dfcbc4005ff2f0fcfd1f888fcdbb.png";